import React from 'react'
import { NextImage } from '@/components/NextImage'
import { useTranslation } from '@/localization/useTranslation'
import { IGlobalProps } from '@/types/cinematics'

import classes from './styles.module.scss'

interface ImageGridProps {
  data: IGlobalProps['sponsors'] | IGlobalProps['subfooter']
  className?: string
}

export const ImageGrid: React.FC<ImageGridProps> = (props) => {
  const { data } = props
  const { t } = useTranslation()

  return (
    <div className={classes.grid} style={data?.style}>
      {data?.rows?.map((row) => (
        <div key={row._id} className={classes.row}>
          {row.columns?.map((column) => {
            const aspectRatio = column?.aspectRatio
            const imageHeight = column?.aspectRatio ? 'auto' : column?.height

            return (
              <div key={column._id} className={classes.column}>
                <a href={column.url} target="_blank" rel="noopener noreferrer">
                  <div
                    className={classes.image__wrapper}
                    style={{
                      aspectRatio,
                      paddingBottom: imageHeight,
                    }}
                  >
                    <NextImage
                      src={column.image}
                      alt=""
                      fill
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                      className={classes.image}
                    />
                  </div>
                  {column.text && <div className={classes.text}>{t(column.text)}</div>}
                </a>
              </div>
            )
          })}
        </div>
      ))}
    </div>
  )
}
